import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import CoachApp from './coach/CoachApp';
import CoachGate from './coach/gate/CoachGate';
import * as serviceWorker from './serviceWorker';

// 路由层（公网部署模式）：
// - 默认入口 = 教练模式（CoachGate + CoachApp）
//   因为 Vercel 是纯静态部署，原转播模式依赖 WebSocket 后端，没法在静态环境工作
// - 只有 URL 显式带 ?mode=broadcast 才尝试加载原 App（本地接后端时可用）
//   公网用户拿到 https://xxx.vercel.app/ 直接进密码门，零额外步骤
const params = new URLSearchParams(window.location.search);
const isBroadcast = params.get('mode') === 'broadcast';

const Root = isBroadcast
  ? App
  : () => (
      <CoachGate>
        <CoachApp />
      </CoachGate>
    );

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
